import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../core/services/authorization/authorization.service';
import { RedirectService } from '../core/services/redirect/redirect.service';
import { ConfigService } from '../core/services/config.service';
import { AuthenticationService } from '../core/services/authentication/authentication.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ClientService } from '../core/services/client/client.service';
import { User } from '../shared/models/user';
import { ClientsList } from '../shared/models/app.config';
import { LoaderService } from '../core/services/loader/loader.service';
import { AlertBoxComponent } from '../shared/components/alert-box/alert-box.component';
import { Constants } from '../shared/constants';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  currentUser: User;
  currentUserSubscription: Subscription;

  selectedClient: any;
  selectedClientSubscription: Subscription;

  modules: any;
  handleDashboard = true;
  showDashboard = true;
  canAccessWaiver: Boolean = false;

  clientList: any;
  clientListSubscription: Subscription;
  insuredPermission: boolean;
  claimsManagementPermission: boolean;
  PaymentManagementPermission: boolean;
  WaiverManagementPermission: boolean;
  moduleWiseClients: ClientsList = new ClientsList();
  moduleChangedSubject: Subscription;
  noOfModules = 0;
  noOfModuleLoaded = 0;
  handleSchoolslectionSubscription: Subscription;
  moduleClientsSubscription: Subscription;
  clientRepoSubscription: Subscription;
  modulesMasterData: any;
  dialogBox: any;
  supportEmail: any;

  constructor(
    private authorizationService: AuthorizationService,
    private redirectService: RedirectService,
    private configService: ConfigService,
    private authService: AuthenticationService,
    private clientService: ClientService,
    private loaderService: LoaderService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog
  ) {
    this.supportEmail = this.configService.supportEmail;
    this.modules = JSON.parse(JSON.stringify(this.configService.modules));
    this.modulesMasterData = JSON.parse(JSON.stringify(this.configService.modules));

    // Subscribe to Current User
    this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
      this.currentUser = user;
      this.updateSubFeatureTiles();
      this.checkPermissions();
    });
    // Subscribe for Selected Client
    this.selectedClientSubscription = this.clientService.selectedClient.subscribe(client => {
      if (client) {
        if (client?.Number !== this.selectedClient?.Number) {
          this.selectedClient = client;
          this.checkPermissions();
          this.updateClientWiseSubFeatureTiles();
        }

      }
    });
    // Subscribe for Client List
    this.clientListSubscription = this.clientService.clientList.subscribe(clientList => {
      if (clientList) {
        this.clientList = clientList;
      }
    });

    this.handleSchoolslectionSubscription = this.clientService.handleSchoolSelect.subscribe(con => {
      this.handleDashboard = con;
    });
    this.moduleClientsSubscription = this.clientService.moduleWiseClients.subscribe(moduleClients => {
      this.clients = moduleClients?.AllClients;
      this.moduleWiseClients = moduleClients;
      if (this.clients) {
        this.clientService.setClientList(this.clients);
        if (this.clients.length === 1) {
          this.clientService.setSelectedClient(this.clients[0]);
        }
        this.updateClientWiseSubFeatureTiles();
      }
    });

  }

  ngOnDestroy() {
    this.selectedClientSubscription.unsubscribe();
    this.clientService.handleClientList(true);
    // this.moduleChangedSubject.unsubscribe();
    this.handleSchoolslectionSubscription.unsubscribe();
    this.moduleClientsSubscription.unsubscribe();
  }

  ngOnInit() { }

  checkPermissions(): void {
    if (this.currentUser && this.selectedClient) {
      this.insuredPermission = this.currentUser.profile.Permissions.InsuranceManagement?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) === -1;
      this.claimsManagementPermission = this.currentUser.profile.Permissions.ClaimsManagement?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) === -1;
      this.PaymentManagementPermission = this.currentUser.profile.Permissions.PaymentManagement?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) === -1;
      this.WaiverManagementPermission = this.currentUser.profile.Permissions.WaiverManagement?.AllowedClientIds?.indexOf(this.selectedClient.Id.toString()) === -1 || Object.keys(this.currentUser.profile.Permissions).indexOf('WaiverManagement') === -1;
    }
    else if (this.currentUser) {
      this.WaiverManagementPermission = Object.keys(this.currentUser.profile.Permissions).indexOf('WaiverManagement') === -1 || this.currentUser.profile.Permissions.WaiverManagement?.AllowedClientIds?.length === 0;
    }
  }

  updateSubFeatureTiles(): void {
    //this.loaderService.showLoader();
    if (!this.selectedClient) {
      this.modules.forEach(element => {
        const module = this.currentUser.profile.Permissions[element.permission];
        if (module) {
          element.blocks = element.blocks.filter(e => {
            return Object.keys(module).map(e => e = e.toLowerCase()).includes(e.blockName.replaceAll(' ', '').toLowerCase());
          });
        }
      });
    }
  }
  hideOnDashboard(blockName) {
    const hideList = [
      'Enrollments',
      'Elections',
      'Submit Lists'
    ];
    return hideList.indexOf(blockName) > -1;
  }

  canAccess(name: string) {
    const flag = this.authorizationService.canAccess({ permission: name });
    console.log(name);
    if (name === 'WaiverManagement') {
      this.canAccessWaiver = flag;
    }
    return flag;
  }

  isDisabled(moduleName: string) {
    if (this.authorizationService.canAccess({ permission: moduleName })) {
      return true;
    }

    return false;
  }

  getFullUrl(module) {
    if (module.transform) {
      return this.redirectService.getFullUrl(module.url, true);
    } else {
      return module.url;
    }
  }

  getMyAccountToken() {
    this.authService.goToMyAccountLite(0, 0);
  }

  // Client Select
  clients = [];
  clientMasterList = [];
  selectedModule: any;

  isWaiverInternalAdminRole() {
    return this.currentUser.profile.Roles.indexOf('rWaiver Management Internal Admin') > -1;
  }

  createClientList(filteredClients) {
    const clients = JSON.parse(JSON.stringify(this.clientMasterList));
    clients.forEach(client => {
      const checkClient = filteredClients.find((c) => c.Id === client.Id);
      client.hasAccess = checkClient ? true : false;
    });

    return clients;
  }

  showSelectClient(module) {
    const permission = module.module;
    let moduleName = permission.startsWith(Constants.WaiverManagement) ? Constants.WaiverManagement :
      permission.startsWith(Constants.ClaimsManagement) ? Constants.ClaimsManagement : permission.startsWith(Constants.PaymentManagement) ? Constants.PaymentManagement : permission.startsWith(Constants.InsuranceManagement) ? Constants.InsuranceManagement : '';
    let clientList: any;
    if (moduleName === '') {
      clientList = this.moduleWiseClients.AllClients;
      this.showClient(module, clientList);
    }
    else if (moduleName != '' && this.moduleWiseClients[moduleName]) {
      clientList = this.moduleWiseClients[moduleName];
      this.showClient(module, clientList);
    }
    else {
      // some code
      //this.getClientsByModule(moduleName, module);
    }
  }
  async showClient(module, clientList) {
    // if (module.isAutoConversionEnabled) {
    //   this.clients = clientList.filter(client => client.AutoConversionEnabled);
    // } else if (module.isEmailNotificationEnabled && !this.isWaiverInternalAdminRole()) {
    //   this.clients = clientList.filter(client => client.EmailNotificationEnabled);
    // } else if (module.isEnrollmentRequired && module.isEarlyEnrollment) {
    //   this.clients = clientList.filter(client => client.EnrollmentEnabled && client.EarlyEnrollment);
    // } else if (module.isEnrollmentRequired && !module.isEarlyEnrollment) {
    //   this.clients = clientList.filter(client => client.EnrollmentEnabled && !client.EarlyEnrollment);
    // } else {
    this.clients = clientList;
    // }
    //this.clients = this.createClientList(this.clients);
    this.selectedModule = module;
    this.clients.forEach(client => {
      client.hasAccess = true;
    });
    if (!this.selectedClient && this.clients.length === 1) {
      // check for module tile access
      this.clientService.setSelectedClient(this.clients[0]);
      this.handleClientWisePermission(this.clients[0]);
    }
    else {
      this.clientService.moduleChangedevent(module);
      this.clientService.handleClientList(false);
      this.showDashboard = false;
    }
  }

  handleClientWisePermission(client): void {
    let hasAccess = true;
    if (this.selectedModule.blockName === Constants.ScheduleEmailNotificationsBlockName) {
      hasAccess = (!this.WaiverManagementPermission && client?.EmailNotificationEnabled);
      this.selectedModule.url = hasAccess ? this.selectedModule.url : '/waiver-management';
    }
    else if (this.selectedModule.blockName === Constants.LedgerBillingBlockName) {
      if (!this.moduleWiseClients.ManageSHCBilling.find(f => f.Id === client.Id)) {
        hasAccess = false;
        this.selectedModule.url = '/dashboard';
        this.selectedModule.transform = false;
      }
    }
    else if (this.selectedModule.blockName === Constants.Referrals) {
      if (!this.moduleWiseClients.ManageReferrals.find(f => f.Id === client.Id)) {
        hasAccess = false;
        this.selectedModule.url = '/dashboard';
        this.selectedModule.transform = false;
      }
    }
    this.goToModule(this.selectedModule);
    this.clientService.moduleChangedevent(null);
    if (!hasAccess)
      this.openDialog('FeatureRestricted');
  }

  openDialog(type: string): void {
    let alertBoxData = {};
    if (type === 'FeatureRestricted') {
      alertBoxData = {
        title: 'Notice',
        message: `The feature has not been enabled for your school. Please contact <a href="mailto:${this.supportEmail}">Partner Center Support</a> for assistance.`
      };
    }
    this.dialogBox = this.dialog.open(AlertBoxComponent, {
      width: '400px',
      data: alertBoxData,
      disableClose: false,
      autoFocus: false,
      panelClass: 'search-dialog-container'
    });
  }

  selectClient(client) {
    this.clientService.setSelectedClient(client);
    const hasAccess = client.hasAccess;

    if (hasAccess) {
      this.goToModule(this.selectedModule);
    } else {
      this.closeClientSelect(true);
    }
    this.clientService.moduleChangedevent(null);
  }

  getClientsByModule(moduleName) {
    this.clientService.getAll(moduleName)
      .subscribe(clients => {
        this.moduleWiseClients[moduleName] = clients.Clients;
        this.loaderService.handleSpinner(false);
      });
  }
  goToModule(module) {
    this.redirectService.goToModule(module);
  }

  closeClientSelect(close) {
    this.showDashboard = close;
    this.handleDashboard = !close;
  }

  updateClientWiseSubFeatureTiles(): void {
    if (this.selectedClient && this.currentUser && this.clients.length > 0) {
      this.modules.forEach(element => {
        const module = this.currentUser?.profile?.Permissions[element.permission];
        if (module) {
          let _blocks = this.modulesMasterData.find(m => m.blockName === element.blockName)?.blocks.filter(e => {
            return Object.keys(module).map(e => e = e.toLowerCase()).includes(e.blockName.replaceAll(' ', '').toLowerCase());
          });
          if (element.permission === Constants.WaiverManagement && !this.WaiverManagementPermission) {
            if (!this.selectedClient?.EmailNotificationEnabled) {
              _blocks = _blocks.filter(e => {
                return e.blockName !== 'Schedule Email Notifications';
              });
            }
            element.blocks = _blocks;
          }
          if (element.permission === Constants.ClaimsManagement && !this.claimsManagementPermission) {
            if (!this.moduleWiseClients.ManageSHCBilling?.find(f => f.Id === this.selectedClient.Id)) {
              _blocks = _blocks.filter(e => {
                return e.blockName !== 'Manage SHC Billing';
              });
            }
            if (!this.moduleWiseClients.ManageReferrals?.find(f => f.Id === this.selectedClient.Id)) {
              _blocks = _blocks.filter(e => {
                return e.blockName !== 'Manage Referrals';
              });
            }
            element.blocks = _blocks;
          }
          if (element.permission === Constants.PaymentManagement && this.PaymentManagementPermission || element.permission === Constants.InsuranceManagement && this.insuredPermission) {
            element.blocks = _blocks;
          }
        }
        else if (element.permission === Constants.WaiverManagement)
          element.blocks = this.modulesMasterData.find(m => m.blockName === element.blockName)?.blocks;
        // else
        //   element.blocks = [];
      });

    }
  }
}
